/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type DevelopmentOrganisation_organisation$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentProjectConsortium_development$ref: FragmentReference;
declare export opaque type DevelopmentProjectConsortium_development$fragmentType: DevelopmentProjectConsortium_development$ref;
export type DevelopmentProjectConsortium_development = {|
  +broker: ?{|
    +organisation: ?{|
      +$fragmentRefs: DevelopmentOrganisation_organisation$ref
    |}
  |},
  +developer: ?{|
    +$fragmentRefs: DevelopmentOrganisation_organisation$ref
  |},
  +architect: ?{|
    +$fragmentRefs: DevelopmentOrganisation_organisation$ref
  |},
  +generalContractor: ?{|
    +$fragmentRefs: DevelopmentOrganisation_organisation$ref
  |},
  +$refType: DevelopmentProjectConsortium_development$ref,
|};
export type DevelopmentProjectConsortium_development$data = DevelopmentProjectConsortium_development;
export type DevelopmentProjectConsortium_development$key = {
  +$data?: DevelopmentProjectConsortium_development$data,
  +$fragmentRefs: DevelopmentProjectConsortium_development$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "DevelopmentOrganisation_organisation"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentProjectConsortium_development",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "broker",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Organisation",
          "kind": "LinkedField",
          "name": "organisation",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organisation",
      "kind": "LinkedField",
      "name": "developer",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organisation",
      "kind": "LinkedField",
      "name": "architect",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organisation",
      "kind": "LinkedField",
      "name": "generalContractor",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "DevelopmentProduct",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'df09a5d175ac4cb9ebfbcb365210c28c';

export default node;
